<template>
   <b-container>
      <PageTitle title="Questionnaires" />
      <QuestionnaireReviewForm v-if="loaded" is-project />
   </b-container>
</template>

<script>
import QuestionnaireReviewForm from './widgets/QuestionnaireReviewForm.vue';
import {mapGetters} from 'vuex';

export default {
   components: {
      QuestionnaireReviewForm,
   },

   data() {
      return {
         loaded: false,
      };
   },

   computed: {
      ...mapGetters({
         activeStudyId: 'companies/activeStudyId',
         hasQuestionnaireAssignment: 'progress/hasQuestionnaireAssignment',
      }),

      companyId() {
         return this.$route.params.id;
      },

      questionnaireId() {
         return this.$route.params.questionnaireId;
      },
   },

   methods: {
      /** Load the project questionnaire data */
      async fetchData() {
         let requests = [];
         requests.push(
            this.$store.dispatch('questionnaire/loadProjectQuestionnaire', {
               questionnaireId: this.questionnaireId,
               joinProject: true,
            })
         );
         requests.push(
            this.$store.dispatch('uploads/loadCompanyUploadCategories', {
               companyId: this.companyId,
               summary: true,
               force: false,
            })
         );
         requests.push(
            this.$store.dispatch('questionnaire/loadQuestionnaires', {companyId: this.companyId})
         );
         await this.loadPage(requests);
         this.loaded = true;
      },
   },

   async created() {
      await this.fetchData();
   },

   watch: {
      async activeStudyId() {
         if (this.isActiveStudyInSetupStage) {
            this.$router.push({name: 'Home'});
            return;
         }
         if (!this.hasQuestionnaireAssignment) {
            this.$router.push({name: 'Home'});
         } else {
            this.loaded = false;
            await this.fetchData();
         }
      },
   },
};
</script>
